import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=ad38bf4c&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "./Event.vue?vue&type=style&index=0&id=ad38bf4c&prod&scoped=true&lang=css"
import style1 from "./Event.vue?vue&type=style&index=1&id=ad38bf4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad38bf4c",
  null
  
)

export default component.exports